import { BrandingTheme } from '@torticity/types'

import { Theme } from './theme'

const config: Theme = {
  key: BrandingTheme.TEAL,
  label: 'teal',
  tokens: {
    'primary-button': [
      'tw-bg-teal-600',
      'hover:tw-bg-teal-900',
      'tw-text-white',
      'tw-py-4',
      'tw-px-6',
      'tw-rounded-full',
      'tw-font-bold',
      'tw-text-md',
      'tw-cursor-pointer',
      'disabled:tw-opacity-50',
      'disabled:tw-cursor-not-allowed',
    ],
    'secondary-button': [
      'tw-border-teal-200',
      'tw-bg-teal-100',
      'tw-text-teal-950',
      'hover:tw-bg-teal-300',
      'active:tw-bg-teal-400',
      'tw-cursor-pointer',
    ],
    'tertiary-button': [
      'tw-bg-white',
      'tw-border-2',
      'tw-border-teal-600',
      'tw-text-teal-900',
      'hover:tw-bg-teal-50',
      'active:tw-bg-teal-100',
      'tw-rounded-full',
      'tw-font-semibold',
      'tw-text-md',
      'tw-py-2',
      'tw-px-6',
      'tw-cursor-pointer',
    ],
    'primary-text': ['tw-text-teal-700'],
    'header-nav': ['!tw-bg-teal-900'],
    'header-active-item': [
      'tw-font-semibold',
      'tw-text-teal-800',
      'tw-bg-white',
      'tw-bg-opacity-80',
    ],
    'loading-spinner': ['tw-fill-teal-600'],
    'primary-icon': ['tw-fill-teal-500', 'tw-text-teal-500'],
    'secondary-icon': [
      'tw-text-teal-800',
      'tw-bg-teal-100',
      'tw-flex',
      'tw-flex-shrink-0',
      'tw-content-center',
      'tw-items-center',
      'tw-justify-center',
      'tw-rounded-full',
    ],
    'tertiary-icon': ['tw-fill-teal-800', 'tw-text-teal-700'],
    'auth-footer': ['tw-text-white', '!tw-bg-teal-800'],
    'secondary-text': ['tw-text-teal-500'],
    'linear-gradient': ['tw-to-teal-500', 'tw-from-teal-900'],
    'light-linear-gradient': ['tw-bg-teal-500'],
    'dark-linear-gradient': ['tw-bg-teal-800'],
    'light-background': ['tw-bg-teal-50'],
    'dark-background': ['tw-bg-teal-700'],
    'tracker-dots': ['tw-border-teal-500', 'tw-bg-teal-50'],
    'active-tracker-dot': ['tw-bg-teal-800', 'tw-rounded-full'],
    'action-flow': ['tw-bg-teal-600'],
    'action-flow-button': ['tw-bg-teal-600', 'hover:tw-bg-teal-900'],
    'mobile-tracker-line': ['tw-bg-teal-500'],
    'bottom-nav-active-bar': ['tw-bg-teal-700'],
    'primary-border': ['tw-border-teal-500'],
    'dark-border': ['tw-border-teal-700'],
    'hover-background': ['hover:tw-bg-teal-50'],
    'hover-border': ['hover:tw-border-teal-500'],
    'important-badge': ['tw-bg-teal-100', 'tw-text-teal-950'],
  },
}

export default config
